import * as React from 'react';
import { ISystemDashboardPanel } from 'library/types/IDashBoardLayout';
import { ISystemDashBoardPanelState } from "library/types/ISystemDashBoardPanelState";

import RGL, { WidthProvider } from 'react-grid-layout';

export class SystemDashboardPanel extends React.PureComponent<ISystemDashboardPanel, ISystemDashBoardPanelState, any> {

    static defaultProps = {
        canBeArchived: true,
        canBeDragged: true,
        canBeResizable: true,
        canBeMinimized: true,
        canBeHidden: true,
        static: false,
        
        //className: "layout",
        //rowHeight: 35,
        //onLayoutChange: function () { },
        //cols: 4// { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 },                                                                                                                                vfd v         
        // initialLayout: generateLayout()
    };

    defaultState = {
        isArchived: false,
        isMinimized: false,
        isHidden: false
    };

    constructor(props: ISystemDashboardPanel) {
        super(props);
    }

    // button templates
    historyIcon = () => <a onClick={this.handleHistoryClick} className="" title="History"><span className="icon-clock"></span></a>;
    hideButton = () => <a onClick={this.handleHideClick} className="panel-hide-btn"><span className="icon-eye_hidden" title="Hide Panel"></span></a>;
    collapseIcon = () => <a onClick={this.handleCollapseClick} title="Collapse Panel" className="panel-collapse-btn active"><span className="icon-arrow_down"></span></a>;
    archiveIcon = () => <a onClick={this.handleArchiveClick} className=""><span className="icon-archive" title="Archive"></span></a>;
    refreshIcon = () => <a onClick={this.handleRefreshClick} className="" title="Reload"><span className="icon-refresh"></span></a>;
    addIcon = () => <a onClick={this.handleAddClick} data-toggle="modal" data-target="#alertsAllergiesPopup" className="btn btn-default" title="Add"><span className="icon-add"></span>Add</a>;

    // event handlers
    handleHideClick = () => {
        this.setState({ isHidden: !this.state.isHidden });
    };

    handleHistoryClick = () => {
        if (this.props.onHistoryClick)
            this.props.onHistoryClick();
    };

    handleCollapseClick = () => {
        this.setState({ isCollapsed: !this.state.isCollapsed });
    };

    handleArchiveClick = () => {
        if (this.props.onArchiveClick)
            this.props.onArchiveClick();
    };

    handleRefreshClick = () => {
        if (this.props.onRefreshclick)
            this.props.onRefreshclick();
    };

    handleAddClick = () => {
        if (this.props.onHandleClick)
            this.props.onHandleClick();
    };

    render() {
        return (<div key={this.props.key} style={{ background: "white" }}
            data-grid={{
                x: this.props.x, y: this.props.y, w: this.props.width, h: this.props.height, isDraggable: this.props.canBeDragged,
                static: this.props.static
            }}>
            {this.props.isSimple ? this.props.component :
                <div className="tiles tiles-grid">
                    <div className="tiles-top-sec">
                        <div className="tiles-top-sec-left">
                            <h4>{this.props.label}</h4>
                        </div>
                    </div>
                    <div className="tiles-top-sec-right">
                    </div>
                    <div className="tiles-btm-sec d-block">
                        {this.props.component}
                    </div>
                </div>
            }
        </div>)
        //return <div key={this.props.key} style={{ background: "white" }}
        //    data-grid={{
        //        x: this.props.x, y: this.props.y, w: this.props.width, h: this.props.height, isDraggable: this.props.canBeDragged,
        //        static: this.props.static
        //    }}>
        //    <span>
        //    <div className="tiles tiles-grid">
        //        <div className="tiles-top-sec">
        //            <div className="tiles-top-sec-left">
        //                <h4>{this.props.label}</h4>
        //            </div>
        //        </div> 
        //        <div className="tiles-top-sec-right">
        //            {this.addIcon ? this.addIcon : null}
        //            {this.refreshIcon ? this.refreshIcon : null}
        //            {this.props.canBeHidden ? this.hideButton : null}
        //            {this.props.canBeArchived ? this.archiveIcon : null}
        //            {this.props.canBeMinimized ? this.collapseIcon : null}
        //        </div>
        //        <div className="tiles-btm-sec d-block">
        //            {this.props.component}
        //        </div>
        //        </div>
        //    </span>
        //</div>;
    }
}
